import { Box } from "@mui/material";
import { AppImageDimension } from "app/appImages";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";

///
export const RightImage = () => {
    const { localContent: { state }, helper } = useCardContext();

    if (state != "contracted" || helper.hasOneImageOnly || helper.hasOneVideoOnly || helper.hasOneAudioOnly || helper.hasPresentation)
        return null;

    const thumbnailUrl = helper.cardImage()?.thumbnailUrl;
    return thumbnailUrl
        ? <Box sx={{ width: AppImageDimension.ThumbnailLg.width, height: AppImageDimension.ThumbnailLg.height }}>
            <img src={thumbnailUrl} style={{ width: "inherit", height: "inherit", objectFit: "contain" }} />
        </Box>
        : null;
};
